// extracted by mini-css-extract-plugin
module.exports = {"img":"Dialog_img__2_mzc","header":"Dialog_header__24qVB","body":"Dialog_body__2v9zY","button":"Dialog_button__TAw0M","dialogPaper":"Dialog_dialogPaper__3y8pA"};